import React from "react";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import {
  PrimaryLarge,
  PrimarySmall
} from "@streeteasy/design-system/typography";

import ResourcesPrimaryModule from "../ResourcesPrimaryModule";
import ResourcesSecondaryModule from "../ResourcesSecondaryModule";
import * as S from "./styled";

const Resources = () => (
  <S.ResourcesContainer>
    <PrimaryLarge as="h2">Master the market with helpful content</PrimaryLarge>
    <ResourcesPrimaryModule />
    <PrimarySmall>Guides to show you the way</PrimarySmall>
    <ResourcesSecondaryModule />
    <S.Text>
      Find more articles in <TextLink href="/blog/">StreetEasy Reads.</TextLink>
    </S.Text>
  </S.ResourcesContainer>
);

export default Resources;
